module.exports = __webpack_public_path__ + "img/qrcode.514fbc52.png";